module.exports = __webpack_public_path__ + "img/chongz.49a65820.svg";